import React, { useState } from "react";
import { FaChevronDown, FaChevronUp } from "react-icons/fa";

const faqsLeft = [
  {
    question: "What will I learn from this course?",
    answer:
      "You’ll gain practical business skills in entrepreneurship, finance, and marketing to help you start, manage, and grow a successful business.",
  },
  {
    question: "How long does the course take to complete?",
    answer:
      "Complete your training in just 1 month with two dynamic classes per week! Our flexible schedule ensures you learn efficiently, gain real-world skills, and stay motivated — all without disrupting your daily routine.",
  },
  {
    question: "Will I receive a certificate after finishing?",
    answer:
      "Absolutely! JK Associates & Chartered Skills will provide a collaborative certificate after successful completion. You’ll receive an accredited certificate officially recognizing your skills and achievements, enhancing your professional profile and helping you stand out in the job market or business world.",
  },
];

const faqsRight = [
  {
    question: "Is the course fully online or blended?",
    answer:
      "This is an in-person practical course, designed for hands-on learning and real interaction. You’ll benefit from face-to-face guidance, practical exercises, and direct mentorship from industry experts at JK Associates.",
  },
  {
    question: "Do I need any prior experience to enroll?",
    answer:
      "No prior experience is needed! This skill development course is designed for beginners — guiding you step-by-step from the basics to professional-level expertise.",
  },
];

const FAQSection = () => {
  const [openLeft, setOpenLeft] = useState(null);
  const [openRight, setOpenRight] = useState(null);

  const faqStyle = (isOpen) => ({
    backgroundColor: isOpen ? "#0d6efd" : "#fff",
    color: isOpen ? "#fff" : "#333",
    borderRadius: "12px",
    padding: "18px 20px",
    boxShadow: "0 4px 12px rgba(0,0,0,0.05)",
    cursor: "pointer",
    transition: "all 0.3s",
  });

  const answerStyle = {
    marginTop: "10px",
    fontSize: "15px",
    lineHeight: "1.6",
    color: "#fff",
  };

  return (
    <section style={{ padding: "60px 20px", backgroundColor: "#f8f9fa" }}>
      {/* Top Left Radius Background */}
      <div
        style={{
          backgroundColor: "#0d6efd",
          color: "white",
          padding: "40px 30px",
          borderTopLeftRadius: "40px",
          borderBottomRightRadius: "10px",
          marginBottom: "40px",
        }}
      >
        <h2 style={{ fontSize: "32px", marginBottom: "15px" }}>
          Frequently Asked Questions
        </h2>
        <p style={{ fontSize: "16px", lineHeight: "1.6", margin: 0 }}>
          Here are some common questions and answers to help you understand the course better.
        </p>
      </div>

      {/* FAQ Grid */}
      <div style={{ display: "flex", gap: "20px", flexWrap: "wrap" }}>
        {/* Left FAQs */}
        <div style={{ flex: "1", minWidth: "300px", display: "flex", flexDirection: "column", gap: "15px" }}>
          {faqsLeft.map((faq, index) => {
            const isOpen = openLeft === index;
            return (
              <div
                key={index}
                style={faqStyle(isOpen)}
                onClick={() => setOpenLeft(isOpen ? null : index)}
              >
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                  <span style={{ fontWeight: "600", fontSize: "16px" }}>{faq.question}</span>
                  {isOpen ? <FaChevronUp /> : <FaChevronDown />}
                </div>
                {isOpen && <p style={answerStyle}>{faq.answer}</p>}
              </div>
            );
          })}
        </div>

        {/* Right FAQs */}
        <div style={{ flex: "1", minWidth: "300px", display: "flex", flexDirection: "column", gap: "15px" }}>
          {faqsRight.map((faq, index) => {
            const isOpen = openRight === index;
            return (
              <div
                key={index}
                style={faqStyle(isOpen)}
                onClick={() => setOpenRight(isOpen ? null : index)}
              >
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                  <span style={{ fontWeight: "600", fontSize: "16px" }}>{faq.question}</span>
                  {isOpen ? <FaChevronUp /> : <FaChevronDown />}
                </div>
                {isOpen && <p style={answerStyle}>{faq.answer}</p>}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default FAQSection;
